import React, { useContext, memo } from 'react'
import { campaignCreationContext } from '@ts/constants'
import { IStepMeta } from '@/ts/common-types';
import { CiCircleCheck } from "react-icons/ci";

const StepsComponent:React.FC = memo(() => {
    const { currentStep, stepMeta, isStepAccessible, handleStepNavigation } = useContext(campaignCreationContext);

    const handleStepClick = (stepIndex: number) => {
        if (isStepAccessible(stepIndex)) {
            handleStepNavigation(stepIndex);
        }
    };

    return (
        <div
            id="steps"
            className="steps-container"
            style={{
                height: 92,
                backgroundColor: "#f8f9fa",
                padding: "20px 0",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                width: "100%",
            }}
        >
            <div className="steps-wrapper">
                <div className="steps-content">
                    {stepMeta.map((s: IStepMeta, idx: number) => {
                        const isAccessible = isStepAccessible(idx);
                        const isClickable = isAccessible || idx <= currentStep;
                        
                        return (
                        <div
                            key={idx}
                            className={`step-item ${
                                idx <= currentStep ? "active" : "inactive"
                            }`}
                            onClick={() => isClickable && handleStepClick(idx)}
                            style={{
                                cursor: isClickable ? 'pointer' : '',
                            }}
                        >
                            {idx < currentStep ? (
                                <CiCircleCheck
                                    className="step-check-icon"
                                    style={{
                                        color: "#0078aa",
                                        fontSize: "32px",
                                    }}
                                />
                            ) : (
                                <div className="step-icon-container">
                                    <div
                                        className="step-icon"
                                        style={{
                                            backgroundColor:
                                                idx === currentStep
                                                    ? "#0078aa"
                                                    : "#FFFFFF",
                                            border: `1px solid ${
                                                idx === currentStep
                                                    ? "#0078aa"
                                                    : "#D0D5DD"
                                            }`,
                                        }}
                                    >
                                        <span
                                            className="step-number"
                                            style={{
                                                color:
                                                    idx === currentStep
                                                        ? "#FFFFFF"
                                                        : "#2d2d2d",
                                            }}
                                        >
                                            {idx + 1}
                                        </span>
                                    </div>
                                </div>
                            )}
                            <div className="step-text">
                                <div
                                    className="step-title"
                                    style={{
                                        color:
                                            idx === currentStep
                                                ? "#2d2d2d"
                                                : "#2d2d2d",
                                        opacity: idx === currentStep ? 1 : 0.5,
                                    }}
                                >
                                    {s.title}
                                </div>
                                <div
                                    className="step-description"
                                    style={{
                                        color:
                                            idx === currentStep
                                                ? "#919191"
                                                : "#1e1b39",
                                        opacity: idx === currentStep ? 1 : 0.5,
                                    }}
                                >
                                    {s.description}
                                </div>
                            </div>
                        </div>
                        );
                    })}
                </div>
            </div>
        </div>
    );
});

export default StepsComponent